<h1>Edit Password</h1>

<form [formGroup]="editPasswordForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="editPasswordForm.touched && editPasswordForm.invalid">
        <ul>
            <li *ngIf="editPasswordForm.touched && editPasswordForm.controls['newPassword'].errors?.required">Password can't be empty.</li>
            <li *ngIf="editPasswordForm.touched && editPasswordForm.controls['newPassword'].errors?.minlength">Password length is short empty.</li>
            <li *ngIf="editPasswordForm.touched && editPasswordForm.controls['confirmPassword'].errors?.equalTo">Confirm Password not Equal To Password.</li>
            <li *ngIf="editPasswordForm.touched && editPasswordForm.controls['confirmPassword'].errors?.required">Confirm password can't be empty.</li>
        </ul>
    </div>

    <div class="form-group">
        <label for="newPassword">New Password</label>
        <input
            id="newPassword"
            class="form-control w-md-50"
            autofocus="autofocus"
            type="password"
            formControlName="newPassword"
            [ngClass]="{ 'input-validation-error': editPasswordForm.touched && editPasswordForm.controls['newPassword'].invalid }"
        />
    </div>

    <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input
            id="confirmPassword"
            class="form-control w-md-50"
            autofocus="autofocus"
            type="password"
            formControlName="confirmPassword"
            [ngClass]="{ 'input-validation-error': editPasswordForm.touched && editPasswordForm.controls['confirmPassword'].invalid }"
        />
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy">Submit</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
